import React from 'react';
import PropTypes from 'prop-types';
// @mui
import { Box, TableRow, TableHead, IconButton } from '@mui/material';
import i18 from '../../../i18';
import Iconify from '../../../components/iconify';
import {
    StickyTableHeadCell,
    StyledTableCell
} from '../../../components/table/tableCellStyles';
import CheckboxCustom from '../../../components/checkbox';
import { ArrowDownBoldIcon } from '../../../icons-lib';
import { StyledTableSortLabel } from './styles';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)'
};

GridListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
    checkboxCell: PropTypes.bool,
    showMenu: PropTypes.bool
};

export default function GridListHead({
    order,
    orderBy,
    rowCount,
    headLabel,
    numSelected,
    onRequestSort,
    onSelectAllClick,
    checkboxCell = true,
    showMenu
}) {
    const createSortHandler = (property) => () => {
        onRequestSort(property);
    };
    return (
        <TableHead sx={{ height: 20 }}>
            <TableRow>
                {checkboxCell && (
                    <StyledTableCell
                        key="checkbox"
                        sx={{ borderRight: '1px solid #f2f4f4' }}
                        align="center"
                    >
                        <CheckboxCustom
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </StyledTableCell>
                )}
                {headLabel.map((headCell) => {
                    if (headCell.disableGrid) return null;
                    const sortField = headCell.sortField || headCell.id;
                    return (
                        <StyledTableCell
                            key={headCell.id}
                            align={headCell.alignRight ? 'right' : 'left'}
                            sortDirection={
                                orderBy === sortField ? order : false
                            }
                        >
                            <StyledTableSortLabel
                                hideSortIcon
                                active={
                                    orderBy === sortField
                                }
                                IconComponent={ArrowDownBoldIcon}
                                direction={
                                    orderBy === sortField
                                        ? order
                                        : 'asc'
                                }
                                sx={orderBy === sortField ? { backgroundColor: 'primary.lightest' } : {}}
                                onClick={createSortHandler(sortField)}
                            >
                                {headCell.label
                                    ? i18.t(`columns.${headCell.label}`)
                                    : ''}
                                {orderBy === sortField ? (
                                    <Box sx={{ ...visuallyHidden }}>
                                        {order === 'desc'
                                            ? 'sorted descending'
                                            : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </StyledTableSortLabel>
                        </StyledTableCell>
                    );
                })}
                {showMenu && (
                    <StickyTableHeadCell
                        key="menu"
                        align="right"
                        sx={{ borderLeft: '1px solid #f2f4f4' }}
                    >
                        <IconButton color="inherit" p={0} m={0}>
                            <Iconify icon="mynaui:table" />
                        </IconButton>
                    </StickyTableHeadCell>
                )}
            </TableRow>
        </TableHead>
    );
}
